module.exports = __webpack_public_path__ + "img/avatar.166bf8e6.png";